import { createSlice } from '@reduxjs/toolkit';
import ApiListDev from '../resources/json/listOfApi-dev.json';
import ApiListLocal from '../resources/json/listOfApi-local.json';
import ApiListTest from '../resources/json/listOfApi-test.json';
import ApiListProd from '../resources/json/listOfApi-prod.json';


let initialState = {apiList: {}};

if (window.REACT_APP_ENV?.toUpperCase() === 'DEV') {
   initialState = {apiList: ApiListDev};
} else if (window.REACT_APP_ENV?.toUpperCase() === 'PROD') {
  initialState = {apiList: ApiListProd};
} else if (window.REACT_APP_ENV?.toUpperCase() === 'TEST') {
  initialState = {apiList: ApiListTest};
}else{
  initialState = {apiList: ApiListLocal};
}


export const apiListSlice = createSlice({
  name: 'apiList',
  initialState,
  reducers: {
    setApiList: (state,env) => {
        if (window.REACT_APP_ENV?.toUpperCase() === 'DEV') {
            state.apiList = ApiListDev;
        } else if (window.REACT_APP_ENV?.toUpperCase() === 'TEST') {
            state.apiList = ApiListTest;
        } else if (window.REACT_APP_ENV?.toUpperCase() === 'PROD') {
            state.apiList = ApiListProd;
        } else{
          state.apiList = ApiListLocal;
        }
        console.log(state.apiList);
    }
  },
})

export const { setApiList } = apiListSlice.actions;

export default apiListSlice.reducer;